import { Component } from "react";
import { NSALoginPage } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";

class LoginPage extends Component
{
    override render()
    {
        return (
            <NSALoginPage
                product_id={ProductUUID.NAMIRASOFT_NWS_REGION}
            />
        );
    }
}

export default LoginPage;